import React from 'react';
import { useData } from "../../components/context/DataContext";
import { renderFormattedText } from "../../utils/helpers";
import './Footer.css'

const Footer = () => {

    const footerData = useData();
    const refArray = footerData.references[0].refs[1].refarray;
    function OrderedList({ items }) {
        return (
            <ol>
                {refArray.map((item, index) => (
                    <li key={index}>{ renderFormattedText(item) }</li>
                ))}
            </ol>
            );
        }

    return (
        <>
            <footer>
                <div className="references">
                    <h2>{footerData && renderFormattedText(footerData.references[0].refs[0].refhead)}</h2>
                    <OrderedList />
                </div>
                <div className="job-num">
                    {footerData && renderFormattedText(footerData.footer[0].jobcode)}
                </div>
            </footer>
        </>
    );
};

export default Footer;